import IndividualEntrepreneurDTO from './IndividualEntrepreneurDTO';
import JuridicalDTO from './JuridicalDTO';
import DTO from './DTO';

class ApplicantDTO extends DTO {
  constructor(params, isValidInit) {
    const ipAttr = new IndividualEntrepreneurDTO().getAttributes();
    const legalAttr = new JuridicalDTO().getAttributes();
    const attributes = [
      {
        name: 'legal_entity_type',
        type: String,
        validators: {},
        labelKey: 'legal_entity_type',
      },
      {
        name: 'logo_files',
        type: String,
        validators: {},
        labelKey: 'logo_files',
      },
      {
        name: 'commercial_name',
        type: String,
        validators: {},
        labelKey: 'commercial_name',
      },
      {
        name: 'commercial_change_document',
        type: String,
        validators: {},
        labelKey: 'media.commercial_change_document',
      },
      {
        name: 'office_phone',
        type: String,
        validators: {},
        labelKey: 'sp.office_phone',
      },
      {
        name: 'office_email',
        type: String,
        validators: {},
        labelKey: 'sp.office_email',
      },
      {
        name: 'office_name',
        type: String,
        validators: {},
        labelKey: 'sp.office_name',
      },
      {
        name: 'office_name_change_document',
        type: String,
        validators: {},
        labelKey: 'media.sp.office_name_change_document',
      },
      {
        name: 'office_address',
        type: String,
        validators: {},
        labelKey: 'new.sp.legal_address',
      },
      ...ipAttr,
      ...legalAttr,
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default ApplicantDTO;
